import { render, staticRenderFns } from "./VisitorReferralsChart.vue?vue&type=template&id=63f242ce"
import script from "./VisitorReferralsChart.vue?vue&type=script&lang=ts"
export * from "./VisitorReferralsChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports